<template>
  <div>
    <Pos_cart_list/>
  </div>
</template>

<script>
import Pos_cart_list from "@/components/adminArin/pos_system/cart/Pos_cart_list";
export default {
  name: "PosCartList",
  components: {
    Pos_cart_list
  }
}
</script>

<style scoped>

</style>
